import { z } from "zod";

// const serverSchema = z.object({
//   DATABASE_URL: z.url(),
//   BETTER_AUTH_SECRET: z.string().min(1),
//   BETTER_AUTH_URL: z.url(),
//   GOOGLE_CLIENT_ID: z.string(),
//   GOOGLE_CLIENT_SECRET: z.string(),
// });

const clientSchema = z.object({
  NEXT_PUBLIC_SELLER: z.url(),
  NEXT_PUBLIC_BUYER: z.url(),
  NEXT_PUBLIC_ADMIN: z.url(),
  NEXT_PUBLIC_API_URL: z.url(),
});

// const isServer = typeof window === "undefined";

const parseEnv = <T extends z.ZodType>(
  schema: T,
  data: unknown,
  type: string,
): z.infer<T> => {
  const result = schema.safeParse(data);
  if (!result.success) {
    // eslint-disable-next-line no-console
    console.error(
      `❌ Invalid ${type} environment variables:`,
      result.error.format(),
    );
    throw new Error(`Invalid ${type} environment variables`);
  }
  return result.data;
};

// const stagingConfig = {
//   NEXT_PUBLIC_SELLER: "https://exportpadi-seller.dokploy.rokswood.com",
//   NEXT_PUBLIC_BUYER: "https://exportpadi-buyer.dokploy.rokswood.com",
//   NEXT_PUBLIC_ADMIN: "https://exportpadi-admin.dokploy.rokswood.com",
//   NEXT_PUBLIC_API_URL: "https://exportpadi-api.apps.rokswood.com",
// };

// const prodConfig = {
//   NEXT_PUBLIC_SELLER: "https://seller.exportpadi.com",
//   NEXT_PUBLIC_BUYER: "https://exportpadi.com",
//   NEXT_PUBLIC_ADMIN: "https://admin.exportpadi.com",
//   NEXT_PUBLIC_API_URL: "https://api.exportpadi.com",
// };

// const isProd =
//   typeof window !== "undefined" &&
//   window.location.hostname.endsWith("exportpadi.com");

// const config = isProd ? prodConfig : stagingConfig;

const clientEnv = parseEnv(
  clientSchema,
  {
    // NEXT_PUBLIC_SELLER: config.NEXT_PUBLIC_SELLER,
    // NEXT_PUBLIC_BUYER: config.NEXT_PUBLIC_BUYER,
    // NEXT_PUBLIC_ADMIN: config.NEXT_PUBLIC_ADMIN,
    // NEXT_PUBLIC_API_URL: config.NEXT_PUBLIC_API_URL,
    NEXT_PUBLIC_SELLER: process.env.NEXT_PUBLIC_SELLER,
    NEXT_PUBLIC_BUYER: process.env.NEXT_PUBLIC_BUYER,
    NEXT_PUBLIC_ADMIN: process.env.NEXT_PUBLIC_ADMIN,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  },
  "client",
);
// const serverEnv = isServer
//   ? parseEnv(serverSchema, process.env, "server")
//   : ({} as z.infer<typeof serverSchema>);

export const env = { ...clientEnv };
